module.exports = __webpack_public_path__ + "lp/img/vote_neutral.62e7626b.svg";